import React from 'react';

import { IBaseProps } from '../utils';

import styles from './LoadingBlock.module.scss';

export interface ILoadingBlockProps extends IBaseProps {
  /** Defines the style variant of the LoadingBlock */
  variant?: 'default' | 'image';
  imageSize?: 'default' | 'large';
}

export const LoadingBlock: React.FC<ILoadingBlockProps> = ({ variant, className, imageSize, dataTest }) => {
  const variantStyles = styles[variant];
  const imageSizeStyle = variant === 'image' && styles[imageSize];
  return (
    <div className={`${styles.loadingBlock} ${variantStyles} ${imageSizeStyle} ${className}`} data-test={dataTest}>
      <div className={styles.background} />
    </div>
  );
};

LoadingBlock.defaultProps = {
  className: '',
  dataTest: 'loading-block',
  variant: 'default'
};
